<div class="body">
    <div class="search-mode-selector-container">
        <p-button label="Future" (onClick)="getFutureStarting()"></p-button>
        <p-button label="Current" (onClick)="getCurrentBookings()"></p-button>
        <p-button label="All" (onClick)="getAllBookings()"></p-button>
    </div>
    <p-button label="Clear filters" (onClick)="sortById();clearFilters()" styleClass="p-button-warning"></p-button>
</div>
<div>
    <p>Found {{dataLength}} bookings.</p>
</div>
<div *ngIf="isLoading">
    <i class="pi pi-spin pi-spinner" style="font-size: 3em; color: grey;"></i>
</div>
<p-table #dataTable selectionMode="single" [value]="bookings" [paginator]="true" [rows]="50"
    [totalRecords]="bookings.length" [rowsPerPageOptions]="[50, 100]" paginatorPosition="both" [showLoader]="true"
    (onFilter)="filterTable($event)">
    <ng-template pTemplate="header">
        <tr>
            <th [style]="{'width':'120px'}" pSortableColumn="id">
                ID<p-sortIcon field="id"></p-sortIcon> 
            </th>
            <th [style]="{'width':'110px'}" pSortableColumn="isActive">Active
                <p-sortIcon field="isActive"></p-sortIcon>
            </th>
            <th pSortableColumn="firstName">First name
                <p-sortIcon field="firstName"></p-sortIcon>
            </th>
            <th pSortableColumn="lastName">Last name
                <p-sortIcon field="lastName"></p-sortIcon>
            </th>
            <th pSortableColumn="school.name">School
                <p-sortIcon field="school.name"></p-sortIcon>
            </th>
            <th pSortableColumn="languageCourse.code">Course
                <p-sortIcon field="languageCourse.code"></p-sortIcon>
            </th>
            <th pSortableColumn="startDate" [style]="{'width':'110px'}">Start 
                <p-sortIcon field="startDate"></p-sortIcon>
            </th>
            <th pSortableColumn="endDate" [style]="{'width':'110px'}">End
                <p-sortIcon field="endDate"></p-sortIcon>
            </th>
            <th [style]="{'width':'120px'}" pSortableColumn="studentLanguage.name">
                Language
                <p-sortIcon field="studentLanguage.name"></p-sortIcon>
            </th>
            <th [style]="{'width':'120px'}" pSortableColumn="duration">Duration
                <p-sortIcon field="duration"></p-sortIcon>
            </th>
            <th pSortableColumn="totalReceivedInEuro">
                Paid
                <p-sortIcon field="totalReceivedInEuro"></p-sortIcon>
            </th>
            <th pSortableColumn="remainingBalanceInEuro">Due
                <p-sortIcon field="remainingBalanceInEuro"></p-sortIcon>
            </th>
        </tr>
        <tr>
            <th>
                <input #idInput pInputText [style]="{'width':'80px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'id', 'contains')" [value]="$any(dataTable).filters['id']?.value">
            </th>
            <th></th>
            <th>
                <input #firstNameInput pInputText [style]="{'width':'120px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'firstName', 'contains')" [value]="$any(dataTable).filters['firstName']?.value">
            </th>
            <th>
                <input #lastNameInput pInputText [style]="{'width':'120px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'lastName', 'contains')" [value]="$any(dataTable).filters['lastName']?.value">
            </th>
            <th>
                <input #schoolNameInput pInputText [style]="{'width':'120px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'school.name', 'contains')" [value]="$any(dataTable).filters['school.name']?.value">
            </th>
            <th>
                <input #languageCourseInput pInputText [style]="{'width':'120px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'languageCourse.code', 'contains')" [value]="$any(dataTable).filters['languageCourse.code']?.value">
            </th>
            <th></th>
            <th></th>
            <th>
                <input #studentLanguageInput pInputText [style]="{'width':'100px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'studentLanguage.name', 'contains')" [value]="$any(dataTable).filters['studentLanguage.name']?.value">
            </th>
            <th>
                <input #durationInput pInputText [style]="{'width':'70px'}"
                    (input)="dataTable.filter($any($event.target)?.value, 'duration', 'contains')" [value]="$any(dataTable).filters['duration']?.value">
            </th>
            <th>
                <input #paidInput pInputText [style]="{'width':'120px'}"
                (input)="dataTable.filter($any($event.target)?.value, 'totalReceivedInEuro', 'amount')" [value]="$any(dataTable).filters['totalReceivedInEuro']?.value">
            </th>
            <th>
                <input #balanceInput pInputText [style]="{'width':'120px'}"
                (input)="dataTable.filter($any($event.target)?.value, 'remainingBalanceInEuro', 'amount')" [value]="$any(dataTable).filters['remainingBalanceInEuro']?.value">
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-booking>
        <tr [pSelectableRow]="booking" class="data-table-row">
            <td *ngIf="!booking.lvmsId">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                    {{booking.id}}
                </a>
            </td>
            <td *ngIf="booking.lvmsId">
                <a routerLink="/management/edit-booking/{{booking.id}}">
                    {{booking.lvmsId}}
                </a>
            </td>
            <td>
                <span *ngIf="booking.isActive">X</span>
            </td>
            <td>
                <a routerLink="/management/edit-booking/{{booking.id}}">
                    {{booking.firstName}}
                </a>
            </td>
            <td>
                <a routerLink="/management/edit-booking/{{booking.id}}">
                    {{booking.lastName}}
                </a>
            </td>
            <td>
                {{booking.school.name}}
            </td>
            <td>
                {{booking.languageCourse?.code}}
            </td>
            <td>
                {{booking.startDate | date: 'dd/MM/yyyy'}}
            </td>
            <td>
                {{booking.endDate | date: 'dd/MM/yyyy'}}
            </td>
            <td>
                {{booking.studentLanguage.name}}
            </td>
            <td>
                {{booking.duration}}
            </td>
            <td>{{booking.totalReceivedInEuro.toFixed(2)}}</td>
            <td>{{booking.remainingBalanceInEuro.toFixed(2)}}</td>
        </tr>
    </ng-template>
</p-table>